export default __webpack_public_path__ + "static/media/image_HitDownload.99d48a41.svg";